import { useFormik } from 'formik';
import { Survey } from '../../form/props';

export const useSurveyData = (survey?: Survey) => {
    const formik = useFormik<Survey>({
        initialValues: {
            code: survey?.code || '',
            title: survey?.title || '',
            description: survey?.description || '',
            advisor_script: survey?.advisor_script || '',
            status: survey?.status || 'active',
        },
        enableReinitialize: true,
        onSubmit: () => {
            // No action needed for detail view
        },
    });

    return {
        formik,
    };
};
